import { ENTITY_TABS, EntityTab } from '../create-entity-element.types';

/**
 * Resolves the host's `tabs` input to the tabs to show. Accepts an array (DOM property) or a
 * comma-separated string (HTML attribute, for example `tabs="organization,facility"`).
 *
 * Order is always the widget's fixed order, regardless of the order the host listed them in.
 * Unknown names are ignored, and a missing, empty or entirely invalid value falls back to every
 * tab, so a typo can never leave the widget with nothing to show.
 */
export function resolveVisibleTabs(value: string | readonly string[] | null | undefined): readonly EntityTab[] {
    const _requested = (typeof value === 'string' ? value.split(',') : Array.isArray(value) ? value : []).map(tab => String(tab).trim().toLowerCase());
    const _visible = ENTITY_TABS.filter(tab => _requested.includes(tab));

    return _visible.length ? _visible : ENTITY_TABS;
}